<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <p>支付</p>
      <div :class="$style.priceWrap">
        <span :class="$style.price" v-if="!currentCoupon.id">￥{{ finalPrice }}元</span>
        <span v-else :class="$style.couponPrice">
          <span :class="$style.fold">￥{{ (finalPrice - currentCoupon.less_money).toFixed(2) }}</span>
          <span :class="$style.normal">￥{{ finalPrice }}元</span>
        </span>
      </div>
      <div :class="$style.couponHint" v-if="currentCoupon.id">
        <img :src="`${$cdnLink}/voucher/notice.png`" />
        <p>
          若该订单确定后未成功支付，该代金券将在
          <span>5分钟后</span>才可再次使用
        </p>
      </div>
      
      <!--div :class="[$style.voucher, unCouponUse ? $style.noCoupon : '']" @click="showCoupon">
        <span>优惠</span>
        <div :class="[$style.useCoupon, unCouponUse ? $style.noCoupon : '']" v-if="!currentCoupon.id">
          <span v-if="!unCouponUse" :class="$style.saw">查看</span>
          <span>{{ unCouponUse ? '暂无代金券可用' : '您有代金券未使用' }}</span>
          <i :class="`iconfont yw-xiangyou ${$style.icon}`" v-if="!unCouponUse"></i>
        </div>
        <div :class="$style.couponContent" v-else>
          <img :src="`${$cdnLink}/voucher/voucher.png`" />
          <span>{{ currentCoupon.name }}</span>
        </div>
      </div-->
      <img :class="[$style.fanhui]" :src="fanhuiIcon" alt="" v-if="fanhuiIcon" @click="close">
      <i v-else :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="close"></i>
    </header>
    <main>
      <div :class="$style.content" v-show="!qrCodeVisible">
        <RadioGroup :class="[$style.payType, hideWxPayType ? $style.hideWxPayType : '']" v-model="currentPayType">
          <div v-for="(item, index) in chargeList" :key="index" :class="[$style.listItem, currentPayType == item.pay_type ? $style.selected : '']" @click="checked(item)">
            <div :class="$style.iconItem" :style="`background-color: ${getPayColor(item.img_class_name)}`">
              <img :src="payIcon(item.img_class_name)" />
              <p>{{ item.unite_name }}</p>
              <img v-if="item.recommend === 1 || (ali_gift == 1 && !hideWxPayType && item.img_class_name == 'alipay')" :class="$style.recommend" :src="`${$cdnLink}/wanXin/orangeTheme/tuijian.png`" alt="" />
            </div>
            <img v-if="item.img_class_name == 'alipay' && ali_gift_image" :src="ali_gift_image" alt="" :class="$style.giftHint">
            <div v-if="item.img_class_name != 'alipay' && ali_gift_image" :class="$style.giftHint"></div>
            <Radio :name="item.pay_type" :icon="'circle'" :checked-color="checkedColor" :class="$style.radio">
              <template #icon="props" v-if="hideWxPayType">
                <span v-if="props.checked" :class="$style.checkedRadio" ></span>
                <span v-else :class="$style.unCheckedRadio" ></span>
              </template>
            </Radio>
            <div :class="$style.more" v-if="hideWxPayType" @click.stop="showMorePayType">
              <img :src="`${$cdnLink}/common/more.png`" alt="">
              <span>更多</span>
            </div>
          </div>
        </RadioGroup>
      </div>
      <div :class="$style.btnGroup" v-show="!qrCodeVisible">
        <Button :class="`${$style.btn} yw-btn yw-btn-primary ${!largeStatus ? $style.alone : ''}`" @click="toCharge">确认充值</Button>
        <Button :class="`${$style.btn} yw-btn yw-btn-primary`" @click="showLargeCharge" v-if="largeStatus && largeStatus == 1">大额支付</Button>
      </div>
      <img :class="$style.payQrCode" v-show="qrCodeVisible" :src="qrCodeLink"/>
      <p v-show="qrCodeVisible" :class="$style.payQrCodeTip">{{ imgClassName === 'wechat' ? '使用微信扫一扫，快速支付' : '使用支付宝扫一扫，快速支付' }}</p>
      <iframe id="orderFrame" :class="$style.orderFrame" name="orderFrame" :src="orderIframeLink" v-show="orderShow" sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation"></iframe>
      <transition name="coupon-move">
        <Coupon v-if="couponVisible" @close="emit('close')" @back="closeCoupon" v-model="currentCoupon" :money="finalPrice"></Coupon>
        <GiftCode v-if="giftCodeVisible"></GiftCode>
      </transition>
    </main>
  </div>
</template>
<script>
import Coupon from '../Coupon';
import GiftCode from '../GiftCode.vue';
import { mapActions, mapState } from 'vuex';
import { Button, RadioGroup, Radio } from 'vant';
import isFullScreen from '@/libs/business/fullScreen';
import { cdnLink } from '@/config';
import { buryReport } from '@/libs/business/account'
import { getOutNetIp } from '@/bridge/AppJsBridge'

export default {
  data() {
    return {
      currentPayType: '',
      payUrl:'',
      couponVisible: false, // 是否选中代金券
      currentCoupon: {}, // 当前选中的代金券
      fullScreen: '',
      unCouponUse: false,
      hasDefaultCoupon: false,
      checkedColor: '#ff4f4b',
      fanhuiIcon: '',
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    // 重置防重复点击机制
    this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
    this.getCouponList();
    if (this.chargeList) this.resetRadio();
    this.resetIp()
  },
  computed: {
    ...mapState({
      ali_gift: state => state.pay.ali_gift,
      ali_gift_image: state => state.pay.ali_gift_image,
      chargeList: state => state.pay.chargeList,
      hideWxPayType: state => state.pay.hideWxPayType,
      largeStatus: state => state.pay.large_status,
      orderShow: state => state.pay.orderShow,
      orderInfo: state => state.pay.order_info,
      orderIframeLink: state => state.pay.orderIframeLink,
      imgClassName: state => state.pay.img_class_name,
      qrCodeVisible: state => state.pay.qrCodeVisible,
      qrCodeLink: state => state.pay.qrCodeLink,
      giftCodeVisible: state => state.pay.giftCodeVisible,
      finalPrice: state => {
        if (state.pay.order_info.zfAmount) {
          return parseFloat((state.pay.order_info.zfAmount / 100).toFixed(2));
        } else {
          return 0;
        }
      }
    })
  },
  watch: {
    chargeList(val) {
      if (val.length) {
        this.resetRadio();
      }
    },
    finalPrice(val) {
      if (val) {
        this.getCouponList()
      }
    }
  },
  components: {
    Coupon,
    Button,
    RadioGroup,
    Radio,
    GiftCode
  },
  methods: {
    ...mapActions({
      getPayList: 'voucher/getPayList'
    }),
   
    // 2022.08.05 支付时重新从客户端拿ipv6地址
    resetIp() {
      getOutNetIp((ip) => {
        const { extra_data } = this.$store.state.user;
        const _extraData = JSON.parse(extra_data);
        _extraData.client_ip = ip;
        this.$store.commit('user/CHANGE_STATE', { extra_data: JSON.stringify(_extraData) });
      })
    },
    async getCouponList() {
      if (!this.finalPrice) return;
      const r = await this.getPayList({ money: this.finalPrice });
      if (!r.length) this.unCouponUse = true
      const coupon = r.find(item => item.valid != 0);
      if (coupon) this.hasDefaultCoupon = true;
      this.currentCoupon = coupon || {};
    },
    close() {
      this.$emit('close');
    },
    showCoupon() {
      if (!this.unCouponUse) {
        buryReport(this.hasDefaultCoupon ? 'VOUCHER_MAX_VALUE' : 'VOUCHER_NOT_REACH_CONDITION')
      }
      this.couponVisible = true;
    },
    checked(e) {
      this.currentPayType = e.pay_type;
      this.$store.commit('pay/CHANGE_STATE', {
        pay_type: e.pay_type,
        img_class_name: e.img_class_name,
        isQrCode: e.isQrCode || false
      });
    },
    showMorePayType() {
      this.$store.commit('pay/showMorePayType');
    },
    payIcon(type) {
      if (type === 'alipay') return this.hideWxPayType ? `${this.$cdnLink}/common/zfb.png` : `${this.$cdnLink}/wanXin/orangeTheme/zfb.png`;
      if (type === 'wechat') return `${this.$cdnLink}/wanXin/orangeTheme/weixin.png`;
      if (type === 'huabei') return this.hideWxPayType ? `${this.$cdnLink}/common/myhb.png` : `${this.$cdnLink}/wanXin/orangeTheme/huabei.png`;
      return require('@/assets/images/pay/visa.png');
    },
    getPayColor(type) {
      if (this.hideWxPayType) return '#FFFFFF';
      if (type === 'wechat') return '#3CB034';
      return '#30B4FF';
    },
    toCharge() {
      this.$store.dispatch('pay/placeOrder', this.currentCoupon);
    },
    showLargeCharge() {
      this.$store.commit('pay/CHANGE_STATE', { largeChargeVisible: true });
    },
    closeCoupon() {
      this.couponVisible = false;
    },
    resetRadio() {
      if (this.chargeList.length) {
        this.currentPayType = this.chargeList[0].pay_type;
        this.$store.commit('pay/CHANGE_STATE', {
          pay_type: this.chargeList[0].pay_type,
          img_class_name: this.chargeList[0].img_class_name,
          isQrCode: this.chargeList[0].isQrCode || false
        });
      }
    }
  }
};
</script>
<style lang="scss" module>
@import '../../../assets/css/common.scss';

.wrap {
  width: 6.05rem;
  height: 5.2rem;
  font-size: 0.23rem;
  background: #ffffff;
  border-radius: 0.2rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;
  > header {
    position: relative;
    background-color: #ff4f4b;
    background: url('#{$cdn-url}/wanXin/orangeTheme/payBack.png') no-repeat;
    background-size: 100% 100%;
    color: #ffffff;
    height: 1.6rem;
    > p {
      font-size: 0.38rem;
      height: 0.7rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }
    .fanhui {
      position: absolute;
      top: 0.16rem;
      right: 0.24rem;
      width: 0.2rem;
      height: 0.2rem;
    }
    .priceWrap {
      position: relative;
      height: 0.4rem;
      margin-bottom: 0.16rem;
    }
    .price,
    .couponPrice {
      font-size: 0.36rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'Helvetica Neue', 'Helvetica', 'Arial';
      font-style: normal;
    }
    .couponPrice {
      font-size: 0.4rem;
      text-align: center;
      margin-left: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .normal {
        text-decoration: line-through;
        font-weight: 400;
        font-size: 0.28rem;
        margin-left: 0.1rem;
      }
    }
    > .voucher {
      background: #FFFFFF;
      border-radius: 0.05rem;
      margin: 0.1rem;
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.1rem 0.12rem 0.1rem 0.28rem;
      &.noCoupon {
        background: rgba(255, 255, 255, 0.34);
        > span {
          color: #FFFFFF;
        }
      }
      > span {
        color: $primary-color;
        font-size: 0.28rem;
      }
      .useCoupon {
        border-radius: 0.03rem;
        padding: 0.08rem 0.12rem 0.06rem 0.12rem;
        font-size: 0.22rem;
        color: $primary-color;
        .saw {
          background: $primary-color-1;
          padding: 1px 2px;
          border-radius: 2px;
          margin-right: 4px;
          color: #FFFFFF;
        }
        &.noCoupon {
          background: #F2F2F2;
          color: #343433;
        }
        .icon {
          font-size: 11px;
          margin-left: 4px;
        }
      }
      .couponContent {
        border-radius: 0.18rem;
        font-size: 0.22rem;
        color: #5f1d10;
        display: flex;
        align-items: center;
        > img {
          width: 0.28rem;
          height: 0.28rem;
          margin-right: 0.05rem;
        }
        > span {
          border-radius: 0.03rem;
          padding: 0.08rem 0.12rem 0.06rem 0.12rem;
          background: linear-gradient(90deg, #e9be69, #fbd58d);
        }
      }
    }
    > .couponHint {
      font-size: 0.19rem;
      text-align: center;
      color: #FFFFFF;
      > img {
        width: 0.19rem;
        height: 0.19rem;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
      }
      > p {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  > main {
    .content {
      padding: 0.5rem 0;
      font-weight: bold;
      text-align: center;
      font-size: 0.28rem;
      .payType {
        overflow-x: auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .listItem {
          margin-bottom: 0.1rem;
          padding-bottom: 0.1rem;
          border-bottom: 1px solid #ffffff;
          width: 1.8rem;
          margin: 0 0.1rem;
          .iconItem {
            background: #30b4ff;
            padding: 0.1rem 0;
            text-align: center;
            border-radius: 8px;
            font-size: 0.24rem;
            color: #ffffff;
            position: relative;
            > img {
              width: 0.5rem;
              height: 0.5rem;
              display: inline-block;
              margin-bottom: 0.05rem;
            }
            &:active {
              opacity: 0.8;
            }
            .recommend {
              position: absolute;
              top: 0;
              left: 0.16rem;
              width: 0.2rem;
              height: 0.4rem;
            }
          }
          .radio {
            display: flex;
            justify-content: center;
            margin-top: 0.05rem;
          }
        }
        .giftHint {
          width: 1.8rem;
          height: .28rem;
          margin-top: 0.04rem;
          display: inline-block;
        }
        &.hideWxPayType {
          justify-content: center;
          position: relative;
          padding-bottom: .5rem;
          .listItem {
            margin-bottom: .1rem;
            width: 2.4rem;
            margin: 0 .2rem;
            border: 1px solid #C8C8C8;
            border-radius: .2rem;
            display: flex;
            position: relative;
            padding: .2rem 0 .1rem .48rem;
            box-sizing: border-box;
            &.selected {
              border-color: #FE5550;
            }
            .iconItem {
              padding: .14rem 0;
              text-align: center;
              border-radius: .16rem;
              font-size: .24rem;
              color: #C8C8C8;
              position: relative;
              display: flex;
              align-items: center;
              > img {
                width: .5rem;
                height: .5rem;
                margin-right: .1rem;
                display: inline-block;
              }
              &:active {
                opacity: 0.8;
              }
              .recommend {
                position: absolute;
                top: 0;
                left: .16rem;
                width: .2rem;
                height: .4rem;
              }
            }
            .radio {
              position: absolute;
              left: .1rem;
              top: .28rem;
              .unCheckedRadio {
                display: inline-block;
                width: .2rem;
                height: .2rem;
                border-radius: 50%;
                border: 1px solid #C8C8C8;
              }
              .checkedRadio {
                display: inline-block;
                width: .2rem;
                height: .2rem;
                border-radius: 50%;
                border: 1px solid #FE5550;
                position: relative;
                &:before {
                  position: absolute;
                  content: ' ';
                  left: 50%;
                  top: 50%;
                  transform: translate3d(-50%, -50%, 0);
                  width: .12rem;
                  height: .12rem;
                  border-radius: 50%;
                  background-color: #FE5550;
                }
              }
            }
            .more {
              position: absolute;
              right: 0;
              bottom: 0;
              width: .8rem;
              height: .3rem;
              font-size: .2rem;
              color: #ffffff;
              background-color: #C8C8C8;
              display: flex;
              align-items: center;
              justify-content: center;
              border-top-left-radius: .2rem;
              border-bottom-right-radius: .2rem;
              > img {
                width: .2rem;
              }
            }
          }
          .giftHint {
            position: absolute;
            bottom: -.45rem;
            width: 1.8rem;
            height: .28rem;
            left: 0;
            right: 0;
            margin: auto;
          }
        }
      }
    }
    .btnGroup {
      position: absolute;
      width: 90%;
      height: 0.68rem;
      bottom: 0.2rem;
      left: 5%;
      right: 5%;
      display: flex;
      justify-content: center;
    }
    .btn {
      background: $btn-background;
      color: #ffffff;
      border: none;
      padding: 0 0.6rem;
      height: 0.68rem;
      line-height: 0.68rem;
      border-radius: 0.68rem;
      font-size: 0.24rem;
      margin: 0 0.2rem;
      &.alone {
        padding: 0 1.6rem;
      }
    }
    .submitBtn {
      @include common-button();
    }
    .orderFrame {
      z-index: 999;
      position: fixed;
      width: 100%;
      min-height: 100%;
      text-align: center;
      background: #f4f4f4;
      margin: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border: 0;
    }
    .payQrCode {
      display: block;
      width: 2rem;
      height: 2rem;
      margin: .1rem auto;
    }
    .payQrCodeTip {
      text-align: center;
      font-weight: 800;
    }
  }
  &.fullScreen {
    width: 302px;
    height: 260px;
    font-size: 11px;
    background: #ffffff;
    border-radius: 10px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: $h5-window;
    > header {
      position: relative;
      background: url('#{$cdn-url}/wanXin/orangeTheme/payBack.png') no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
      height: 110px;
      > p {
        font-size: 19px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
      .fanhui {
        position: absolute;
        top: 8px;
        right: 12px;
        width: 10px;
        height: 10px;
      }
      .priceWrap {
        position: relative;
        height: 20px;
        margin-bottom: 8px;
      }
      .price,
      .couponPrice {
        font-size: 18px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'Helvetica Neue', 'Helvetica', 'Arial';
        font-style: normal;
      }
      .couponPrice {
        font-size: 20px;
        text-align: center;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .normal {
          text-decoration: line-through;
          font-weight: 400;
          font-size: 14px;
          margin-left: 5px;
        }
      }
      > .voucher {
        background: #FFFFFF;
        border-radius: 2.5px;
        margin: 5px;
        font-size: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 6px 5px 14px;
        &.noCoupon {
          background: rgba(255, 255, 255, 0.34);
          > span {
            color: #FFFFFF;
          }
        }
        > span {
          color: $primary-color;
          font-size: 14px;
        }
        .useCoupon {
          border-radius: 1.5px;
          padding: 4px 6px 3px 6px;
          font-size: 11px;
          color: $primary-color;
          &.noCoupon {
            background: #F2F2F2;
            color: #343433;
          }
        }
        .couponContent {
          border-radius: 9px;
          font-size: 11px;
          color: #5f1d10;
          display: flex;
          align-items: center;
          > img {
            width: 14px;
            height: 14px;
            margin-right: 2.5px;
          }
          > span {
            border-radius: 2px;
            padding: 4px 6px 3px 6px;
            background: linear-gradient(90deg, #e9be69, #fbd58d);
          }
        }
      }
      > .couponHint {
        font-size: 9px;
        text-align: center;
        color: #FFFFFF;
        > img {
          width: 9px;
          height: 9px;
          display: inline-block;
          vertical-align: middle;
        }
        > p {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
    > main {
      .content {
        padding: 9px 0;
        font-weight: bold;
        text-align: center;
        font-size: 14px;
        .payType {
          overflow-x: auto;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .listItem {
            margin-bottom: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ffffff;
            width: 90px;
            margin: 0 5px;
            .iconItem {
              background: #30b4ff;
              padding: 5px 0;
              text-align: center;
              border-radius: 8px;
              font-size: 12px;
              color: #ffffff;
              position: relative;
              > img {
                width: 25px;
                height: 25px;
                display: inline-block;
                margin-bottom: 2px;
              }
              &:active {
                opacity: 0.8;
              }
              .recommend {
                position: absolute;
                top: 0;
                left: 8px;
                width: 10px;
                height: 20px;
              }
            }
            .radio {
              display: flex;
              justify-content: center;
              margin-top: 2.5px;
            }
          }
          .giftHint {
            width: 90px;
            height: 14px;
            margin-top: 2px;
            display: inline-block;
          }
          &.hideWxPayType {
            justify-content: center;
            position: relative;
            padding-bottom: 25px;
            .listItem {
              margin-bottom: 5px;
              width: 120px;
              margin: 0 10px;
              border: 1px solid #C8C8C8;
              border-radius: 10px;
              display: flex;
              position: relative;
              padding: 10px 0 5px 24px;
              box-sizing: border-box;
              &.selected {
                border-color: #FE5550;
              }
              .iconItem {
                padding: 7px 0;
                text-align: center;
                border-radius: 8px;
                font-size: 12px;
                color: #C8C8C8;
                position: relative;
                display: flex;
                align-items: center;
                > img {
                  width: 25px;
                  height: 25px;
                  margin-right: 5px;
                  display: inline-block;
                }
                &:active {
                  opacity: 0.8;
                }
                .recommend {
                  position: absolute;
                  top: 0;
                  left: 8px;
                  width: 10px;
                  height: 20px;
                }
              }
              .radio {
                position: absolute;
                left: 5px;
                top: 14px;
                .unCheckedRadio {
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  border: 1px solid #C8C8C8;
                }
                .checkedRadio {
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  border: 1px solid #FE5550;
                  position: relative;
                  &:before {
                    position: absolute;
                    content: ' ';
                    left: 50%;
                    top: 50%;
                    transform: translate3d(-50%, -50%, 0);
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background-color: #FE5550;
                  }
                }
              }
              .more {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 40px;
                height: 15px;
                font-size: 10px;
                color: #ffffff;
                background-color: #C8C8C8;
                display: flex;
                align-items: center;
                justify-content: center;
                border-top-left-radius: 10px;
                border-bottom-right-radius: 10px;
                > img {
                  width: 10px;
                }
              }
            }
            .giftHint {
              position: absolute;
              bottom: -22.5px;
              width: 100px;
              height: auto;
              left: 0;
              right: 0;
              margin: auto;
            }
          }
        }
      }
      .btnGroup {
        position: absolute;
        width: 90%;
        height: 34px;
        bottom: 10px;
        left: 5%;
        right: 5%;
        display: flex;
        justify-content: center;
      }
      .btn {
        background: $btn-background;
        color: #ffffff;
        border: none;
        padding: 0 30px;
        height: 34px;
        line-height: 34px;
        border-radius: 34px;
        font-size: 12px;
        margin: 0 10px;
        &.alone {
          padding: 0 80px;
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
      .orderFrame {
        z-index: 999;
        position: fixed;
        width: 100%;
        min-height: 100%;
        text-align: center;
        background: #f4f4f4;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border: 0;
      }
      .payQrCode {
        display: block;
        width: 100px;
        height: 100px;
        margin: 5px auto;
      }
    }
  }
}
</style>
